import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default (Alpine) => {
  Alpine.data('loyalty', () => ({
    loyaltyTier: null,
    pointsBalance: 0,
    pointsEarned: 0,

    init() {
      this._pollForLoyaltyTier();

    },

    _injectPointsBalance() {
       const anchor = document.querySelector('.yotpo-coupons-redemption-widget .yotpo-description')
       const element = document.createElement('div')
       element.classList.add('yotpo-points-balance')
       element.textContent = `You have ${this.pointsBalance} points`;
       anchor.appendChild(element);
    },

    _pollForLoyaltyTier() {
      console.log('polling for loyalty tier');
      const maxTries = 30;
      let tries = 0;

      const interval = setInterval(() => {
        tries++;

        const vipTier = window.swellConfig?.customer?.vip_tier?.name;
        const pointsBalance = window.swellConfig?.customer?.points_balance;
        const pointsEarned = window.swellConfig?.customer?.points_earned;

        if (pointsBalance && pointsEarned) {
          clearInterval(interval);
          this.loyaltyTier = vipTier;
          this.pointsBalance = pointsBalance;
          this.pointsEarned = pointsEarned;
          console.log('pointsBalance', pointsBalance);
          console.log('pointsEarned', pointsEarned);
          console.log('vipTier', vipTier);
          this._injectPointsBalance();
        }

        if (tries >= maxTries) {
          console.log('maxTries reached');
          clearInterval(interval);
        }
      }, 1000);
    },

  }));
};